export default "__VITE_ASSET__ClJ4$pUI__"